import { _ } from 'utils'
import { createEventRoute } from 'utils/routes'
import BoothConfig from './config/BoothConfig'
import CrewConfig from './crew/CrewConfig'
import JobsConfig from './jobs/JobsConfig'
import BoothList from './BoothList'
import AddJob from './jobs/AddJob'

export default {
    boothList: createEventRoute({
        title: _('portal_menu.booths', {}, false),
        path: '/booths',
        component: BoothList,
        exact: true,
        context: 'booth-list'
    }),
    boothCrew: createEventRoute({
        title: _('portal_menu.booth_crew', {}, false),
        path: '/booth/:boothSlug/crew',
        component: CrewConfig,
        exact: true,
        noBreadCrumb: true,
        context: 'booth-crew'
    }),
    boothJobs: createEventRoute({
        title: _('portal_menu.booth_jobs', {}, false),
        path: '/booth/:boothSlug/jobs',
        component: JobsConfig,
        exact: true,
        noBreadCrumb: true,
        context: 'booth-jobs'
    }),
    editBooth: createEventRoute({
        title: _('portal_menu.booth_detail', {}, false),
        path: '/booth/:boothSlug',
        component: BoothConfig,
        exact: true,
        noBreadCrumb: true,
        context: 'booth-detail'
    }),
    addJob: createEventRoute({
        title: _('portal_menu.add_booth_job', {}, false),
        path: '/booth/:boothSlug/new_job',
        component: AddJob,
        exact: true,
        noBreadCrumb: true,
        context: 'booth-job-create'
    }),
}
